import { SearchResultsComponent } from '../../Organisms'
import { LeksikonSearchResultProps } from './props'
import { StyledSearchResult } from './styles'

const LeksikonSearchResult = ({
    results,
    searchedText,
    title,
}: LeksikonSearchResultProps) => {
    return (
        <StyledSearchResult>
            <SearchResultsComponent
                results={results}
                searchedText={searchedText}
                t={{ matches: title }}
            />
        </StyledSearchResult>
    )
}

export default LeksikonSearchResult
